import { ReferenceDetails } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Drawer } from 'braid-design-system';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import type { Reference } from '../types';

import translations from './.vocab';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  reference?: Reference;
}

export const ReferenceDrawer = ({ isOpen, onClose, reference }: Props) => {
  const { t } = useTranslations(translations);
  const {
    referenceSeekPassManagePressed,
    referenceCompletePressed,
    referenceDialogDisplayed,
    referenceDialogPressed,
  } = useAnalytics();

  const onManageClick = () => {
    referenceSeekPassManagePressed();
  };

  const onCompleteClick = () => {
    referenceCompletePressed();
  };

  const onLearnMoreClick = () => {
    referenceDialogPressed({
      callToAction: 'learn more',
      currentPageSection: 'references',
      currentPageSubsection: 'references',
    });
  };
  const onContinueClick = () => {
    referenceDialogPressed({
      callToAction: 'continue to seek pass',
      currentPageSection: 'references',
      currentPageSubsection: 'references',
    });
  };

  const onReferenceDialogDisplayed = () => {
    referenceDialogDisplayed({
      currentPageSection: 'references',
      currentPageSubsection: 'references',
    });
  };

  return (
    <Drawer
      id="edit-reference-drawer"
      data={{ automation: 'edit-reference-drawer' }}
      title={t('Edit reference')}
      width="small"
      open={isOpen}
      onClose={onClose}
      closeLabel={t('Close')}
    >
      {reference ? (
        <ReferenceDetails
          {...reference}
          onManageClick={onManageClick}
          onCompleteClick={onCompleteClick}
          onLearnMoreClick={onLearnMoreClick}
          onContinueClick={onContinueClick}
          onDisplayCompleteReferenceCheckDialog={onReferenceDialogDisplayed}
          onDisplayManageOnSeekPassDialog={onReferenceDialogDisplayed}
        />
      ) : null}
    </Drawer>
  );
};
